if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      // DAVI: Opskrift + garn (bundle) har ingen product-form-knap – brug bundle-knappen i stedet.
      const formBtn = this.productForm
        ? this.productForm.querySelector('.product-info__add-to-cart [name="add"]')
        : null;
      this.bundleBtn = formBtn ? null : this.productSection.querySelector('#bundle-add-to-cart');
      this.realBtn = formBtn || this.bundleBtn;
      this.watchTarget = formBtn
        ? this.productForm
        : (this.bundleBtn ? (this.bundleBtn.closest('.product-info__add-to-cart') || this.bundleBtn) : this.productForm);

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      this.initAddButton();
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      document.body.classList.remove('davi-atc-visible');
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.watchTarget && !theme.mediaMatches.md) {
            // DAVI: På mobil vises panelet, så snart "Tilføj til kurv" ikke er synlig –
            // både før man har scrollet ned til knappen og efter man er scrollet forbi den.
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
        this.updateBodyState();
      });

      if (this.watchTarget) observer.observe(this.watchTarget);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
      window.addEventListener('resize', () => this.updateBodyState());
    }

    /**
     * DAVI: Erstatter "Vælg muligheder"-linket med en rigtig "Tilføj til kurv"-knap.
     * Knappen klikker på produktformularens egen knap (eller bundle-knappen), så valgt farve, antal og
     * kurv-skuffen virker præcis som normalt. Giver feedback: indlæser → ✓ Lagt i kurven.
     */
    initAddButton() {
      const holder = this.querySelector('.card__buttons');
      if (!this.realBtn || !holder) return;

      const isDa = (document.documentElement.lang || '').toLowerCase().startsWith('da');
      this.texts = {
        add: this.realBtn.dataset.addToCartText || (isDa ? 'Tilføj til kurv' : 'Add to cart'),
        added: isDa ? 'Lagt i kurven' : 'Added to cart',
        error: isDa ? 'Prøv igen' : 'Try again'
      };

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn btn--primary davi-sticky-add';
      btn.innerHTML = `
        <span class="davi-sticky-add__label"></span>
        <span class="davi-sticky-add__spinner" aria-hidden="true"></span>
        <span class="davi-sticky-add__check" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>
        </span>`;
      btn.setAttribute('aria-live', 'polite');
      holder.innerHTML = '';
      holder.appendChild(btn);
      this.stickyBtn = btn;
      this.stickyLabel = btn.querySelector('.davi-sticky-add__label');

      this.syncWithRealButton();
      new MutationObserver(() => {
        if (!this.busy) this.syncWithRealButton();
      }).observe(this.realBtn, {
        attributes: true, attributeFilter: ['disabled', 'class'], childList: true, characterData: true, subtree: true
      });

      btn.addEventListener('click', () => this.handleAdd());

      const onSuccess = () => this.finish('is-added', this.texts.added);
      const onError = () => this.finish('is-error', this.texts.error);
      document.addEventListener('on:cart:add', onSuccess);
      document.addEventListener('on:line-item:change', onSuccess);
      document.addEventListener('on:cart:error', onError);
      document.addEventListener('davi:atc:added', onSuccess);
      document.addEventListener('davi:atc:error', onError);
    }

    isUnavailable() {
      return this.realBtn.disabled || (this.bundleBtn && this.realBtn.classList.contains('out-of-stock'));
    }

    syncWithRealButton() {
      if (!this.stickyBtn) return;
      const soldOut = this.isUnavailable();
      this.stickyBtn.disabled = soldOut;
      this.stickyLabel.textContent = soldOut && !this.bundleBtn ? this.realBtn.textContent.trim() : this.texts.add;
    }

    handleAdd() {
      if (this.busy || this.isUnavailable()) return;
      this.busy = true;
      this.pending = true;
      this.stickyBtn.classList.remove('is-added', 'is-error');
      this.stickyBtn.classList.add('is-loading');
      this.realBtn.click();

      // Sikkerhedsnet, hvis der ikke kommer noget svar (fx hvis en app overtager knappen).
      clearTimeout(this.safetyTimer);
      this.safetyTimer = setTimeout(() => {
        if (this.pending) this.reset();
      }, 8000);
    }

    finish(stateClass, text) {
      if (!this.pending) return;
      this.pending = false;
      clearTimeout(this.safetyTimer);
      this.stickyBtn.classList.remove('is-loading');
      this.stickyBtn.classList.add(stateClass);
      this.stickyLabel.textContent = text;

      if (stateClass === 'is-added') {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          bubble.classList.remove('davi-cart-bump');
          // eslint-disable-next-line no-unused-expressions
          bubble.offsetWidth;
          bubble.classList.add('davi-cart-bump');
        }
      }

      setTimeout(() => this.reset(), 2200);
    }

    reset() {
      this.pending = false;
      this.busy = false;
      this.stickyBtn.classList.remove('is-loading', 'is-added', 'is-error');
      this.syncWithRealButton();
    }

    /**
     * DAVI: Sætter en klasse på body, når panelet er synligt på mobil, så flydende knapper
     * (Mayflower Club / cookie-ikon) kan rykkes op over panelet. Panelets højde gemmes i --davi-atc-h.
     */
    updateBodyState() {
      const visible = !this.classList.contains('sticky-atc-panel--out') && !theme.mediaMatches.md;
      document.body.classList.toggle('davi-atc-visible', visible);
      if (visible) {
        document.documentElement.style.setProperty('--davi-atc-h', `${this.offsetHeight}px`);
      }
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
